import NetworkService from "../config/interceptor/interceptor";

export type SupportVideoType = "SUPPORT" | "TESTIMONIAL";

export interface SupportVideo {
  id: number;
  title: string;
  youtubeUrl: string;
  videoType: SupportVideoType;
  createdAt: string;
  updatedAt: string;
}

const unwrap = <T>(response: any): T => response?.data?.data ?? response?.data;

export const fetchSupportVideos = async (
  videoType?: SupportVideoType,
  withLoader: boolean = true
): Promise<SupportVideo[]> => {
  const response = await NetworkService.getInstance().sendHttpRequest({
    url: "support-videos",
    method: "GET",
    params: videoType ? { type: videoType } : undefined,
    withLoader,
    withFailureLogs: true,
  });
  return unwrap<SupportVideo[]>(response);
};

export const createSupportVideo = async (
  title: string,
  youtubeUrl: string,
  videoType: SupportVideoType = "SUPPORT"
): Promise<SupportVideo> => {
  const response = await NetworkService.getInstance().sendHttpRequest({
    url: "support-videos",
    method: "POST",
    data: { title, youtubeUrl, videoType },
    withLoader: true,
    withFailureLogs: true,
  });
  return unwrap<SupportVideo>(response);
};

export const uploadSupportVideo = async (
  title: string,
  videoFile: File,
  videoType: SupportVideoType = "TESTIMONIAL"
): Promise<SupportVideo> => {
  const formData = new FormData();
  formData.append("title", title);
  formData.append("videoFile", videoFile);
  formData.append("type", videoType);

  const response = await NetworkService.getInstance().sendHttpRequest({
    url: "support-videos/upload",
    method: "POST",
    data: formData,
    withLoader: true,
    withFailureLogs: true,
  });
  return unwrap<SupportVideo>(response);
};

export const deleteSupportVideo = async (id: number): Promise<void> => {
  await NetworkService.getInstance().sendHttpRequest({
    url: `support-videos/${id}`,
    method: "DELETE",
    withLoader: true,
    withFailureLogs: true,
  });
};
